// extracted by mini-css-extract-plugin
export default {"list_team":"listtem_list_team__4-p7l","list_item":"listtem_list_item__t4nuA","list":"listtem_list__7-Z0F"};